// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../../../types";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type EmissionsForJourneysFragment = {
  __typename?: "EmissionsForLocationsJourneyResponseObject";
  calculatedEmissions: number;
  travelDistance?: number | null;
  journey: {
    __typename?: "Journey";
    journeyType: Types.JourneyType;
    numberOfPeople: number;
    id: string;
  };
};

export type GetEmissionsForLocationsQueryVariables = Types.Exact<{
  input: Types.GetEmissionsForLocationsInput;
}>;

export type GetEmissionsForLocationsQuery = {
  __typename?: "Query";
  getEmissionsForLocations: Array<{
    __typename?: "GetEmissionsForLocationsResponse";
    locationId: string;
    emissionsForJourneys: Array<{
      __typename?: "EmissionsForLocationsJourneyResponseObject";
      calculatedEmissions: number;
      travelDistance?: number | null;
      journey: {
        __typename?: "Journey";
        journeyType: Types.JourneyType;
        numberOfPeople: number;
        id: string;
      };
    }>;
  }>;
};

export const EmissionsForJourneysFragmentDoc = gql`
  fragment EmissionsForJourneys on EmissionsForLocationsJourneyResponseObject {
    calculatedEmissions
    travelDistance
    journey {
      journeyType
      numberOfPeople
      id
    }
  }
`;
export const GetEmissionsForLocationsDocument = gql`
  query GetEmissionsForLocations($input: GetEmissionsForLocationsInput!) {
    getEmissionsForLocations(input: $input) {
      locationId
      emissionsForJourneys {
        journey {
          journeyType
          numberOfPeople
          id
        }
        calculatedEmissions
        travelDistance
      }
    }
  }
`;

export function useGetEmissionsForLocationsQuery(
  options: Omit<
    Urql.UseQueryArgs<GetEmissionsForLocationsQueryVariables>,
    "query"
  >
) {
  return Urql.useQuery<GetEmissionsForLocationsQuery>({
    query: GetEmissionsForLocationsDocument,
    ...options,
  });
}
